var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDLogoMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_6927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.5568 0H9.44322C4.50401 0 0.5 4.00401 0.5 8.94322V91.0568C0.5 95.996 4.50401 100 9.44322 100H91.5568C96.496 100 100.5 95.996 100.5 91.0568V8.94322C100.5 4.00401 96.496 0 91.5568 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.458 26.6943L53.9443 26.7568L53.9434 26.7578C66.7919 26.7603 77.2451 37.1454 77.2451 50C77.2451 55.5455 75.3071 60.6592 72.0371 64.668L71.7168 65.0527L71.7148 65.0557C71.3067 65.5302 70.8391 65.9978 70.3916 66.4453L70.3926 66.4463C66.1955 70.7084 60.4009 73.3096 54.0049 73.3096H30.6992V26.6924L31.458 26.6943ZM40.1973 63.8047H53.9355C61.5048 63.8047 67.6738 57.6356 67.6738 50.0664C67.6738 42.4972 61.5048 36.3281 53.9355 36.3281H40.1973V63.8047Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5142
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_6927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDLogoMd);
export default __webpack_public_path__ + "static/media/d-logo-md.a2e4c44783cc22117c3fe710724db991.svg";
export { ForwardRef as ReactComponent };